import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { AuthShell } from "../components/AuthShell";
import { useAuth } from "../context/AuthContext";
import { errMsg } from "../lib/api";

const IMG = "https://images.unsplash.com/photo-1509563268479-0f004cf3f58b?auto=format&fit=crop&w=1400&q=80";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const u = await login(email, password);
      toast.success(`Bem-vindo, ${u.name}!`);
      nav(u.role === "admin" ? "/proprietario" : "/painel");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Entrar" kicker="// Acesso" image={IMG}>
      <form onSubmit={submit} className="space-y-5" data-testid="login-form">
        <div className="space-y-1.5">
          <Label>E-mail</Label>
          <Input data-testid="login-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>
        <div className="space-y-1.5">
          <Label>Senha</Label>
          <Input data-testid="login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>
        {error && <p data-testid="login-error" className="text-sm text-red-400">{error}</p>}
        <button data-testid="login-form-submit-button" disabled={loading} className="btn-neon flex w-full items-center justify-center gap-2 rounded-full py-3.5 font-semibold disabled:opacity-50">
          {loading && <Loader2 className="h-4 w-4 animate-spin" />} Entrar
        </button>
        <p className="text-center text-sm text-slate-400">
          Novo por aqui? <Link to="/cadastro" data-testid="login-to-register-link" className="text-cyan-300 hover:underline">Cadastre-se e envie 1 foto grátis</Link>
        </p>
      </form>
    </AuthShell>
  );
}
